import React, { useState } from 'react';
import NewsCardRevamped from './NewsCardRevamped';
// import NewsDetailsModal from './NewsDetailsModal';
import './NewsListStyle.css';
import BrowserModal from './BrowserModal';
import AnalysisModal from './AnalysisModal';

function NewsList({ newsItems, currentTime }) {
    const [selectedNews, setSelectedNews] = useState(null);
    const [selectedAI, setSelectedAI] = useState(null);

    return (
        <>
            <div className="news-list">
                {newsItems.map((item, index) => (
                    <div
                        key={item.link}
                        className="news-item-wrapper"
                        style={{
                            animationDelay: `${Math.min(index * 0.05, 2)}s`
                        }}
                    >
                        <NewsCardRevamped
                            item={item}
                            currentTime={currentTime}
                            onSelect={() => setSelectedNews(item)}
                            onAnalyze={() => setSelectedAI(item)}
                        />
                    </div>
                ))}
            </div>
            {selectedAI && (
                <AnalysisModal
                    item={selectedAI}
                    onClose={() => setSelectedAI(null)}
                    currentTime={currentTime}
                />
            )}
            {selectedNews && (
                <BrowserModal
                    // <NewsDetailsModal
                    item={selectedNews}
                    onClose={() => setSelectedNews(null)}
                    currentTime={currentTime}
                />
            )}
        </>
    );
}

export default NewsList;